<template>
  <div class="flex custom-auth-page">
    <template v-if="isDesktop">
      <span class="video-content-text">
        <!-- <span class="title-video"></span> -->
      </span>
      <div class="video-back"></div>
      <div class="w-full h-100 video-container">
        <video autoplay muted loop>
          <source src="@/assets/video/video_safras.mp4" type="video/mp4" />
        </video>
      </div>
    </template>
    <div class="flex items-center justify-center bg-auth" :class="{ 'w-full ': !isDesktop, 'h-screen': !fromPopup }"
      id="page-login">
      <vs-popup :title="$t('HELP_PRIVACY_POLICY').Title" :active.sync="displayPolicyPage" class="privacy-policy-modal"
        :class="{ 'privacy-policy-modal-mobile': !isDesktop }">
        <privacy-policy v-if="displayPolicyPage"></privacy-policy>
      </vs-popup>
      <vs-popup :title="$t('TERMS_USE').Title" :active.sync="displayPopupTermsCondition" class="terms-condition-modal"
        :class="{ 'terms-condition-modal-mobile': !isDesktop }">
        <terms-use :displayActionButton="false" v-if="displayPopupTermsCondition"></terms-use>
      </vs-popup>

      <!-- <div class="mobile-btn-back">
        <button v-if="!isDesktop" @click="onClose" class="btn-close">
          <feather-icon icon='XIcon'/>
        </button>
      </div> -->

      <!-- START PAGE -->
      <div class="h-full">
        <VuePerfectScrollbar class="auth-content-scroll h-full" :settings="settings" :suppressScrollX="true">

          <div class="items-center w-full login-cont">
            <div slot="no-body" class="full-page-bg-color">
              <div class="login-body">
                <div class="vx-col lg:block lg:w-1/1 logo-click" @click="onClose">
                  <span class="back-login-button" v-if="!fromPopup">
                    <feather-icon icon="XIcon" svgClasses="w-6 h-6" />
                  </span>
                  <vx-tooltip :text="$t('LOGIN').Click_Back" position="bottom" delay=".1s">
                    <div class="logo-login mx-auto" :class="{ 'logo-login-mobile': !isDesktop }"></div>
                  </vx-tooltip>
                </div>
                <div class="w-full center"
                  v-if="!displayEmailTwoFactorAuth && !displayQRCodeTwoFactorAuth && !displayConfirmEmail">
                  <h3 class="mb-1">{{ $t('LOGIN').Enter }}</h3>
                </div>
                <div class="pagecard">
                  <div class="login-tabs-container content-login mt-10"
                    v-if="!displayEmailTwoFactorAuth && !displayQRCodeTwoFactorAuth && !displayConfirmEmail">
                    <div class="form-login">
                      <vs-input name="E-mail" id="email" type="email" v-validate="'required|email'" icon-no-border
                        icon="icon icon-mail" icon-pack="feather" :label="$t('LOGIN').User" v-model.lazy="email"
                        class="w-full mb-2" v-on:keyup.enter="focusPassword" @click="deleteElement" />
                      <span class="text-danger text-sm" v-show="displayElement && errors.has('E-mail')">{{
                        errors.first('E-mail') }}</span>

                      <vs-input id="password" :type="inputPasswordType" :name="$t('LOGIN').Password"
                        v-validate="'required|min:6|max:16'" icon-no-border icon="icon icon-lock" icon-pack="feather"
                        :label="$t('LOGIN').Password" v-model.lazy="password" autocomplete="off"
                        class="w-full space-form" v-on:keyup.enter="onLogin" @click="deleteElement" />
                      <feather-icon v-if="!isInputPasswordTypeText" icon='EyeIcon' svgClasses='h-4 w-4'
                        class='cursor-pointer input-password-icon-eye' @click.stop="switchInputPasswordType" />
                      <feather-icon v-if="isInputPasswordTypeText" icon='EyeOffIcon' svgClasses='h-4 w-4'
                        class='cursor-pointer input-password-icon-eye' @click.stop="switchInputPasswordType" />

                      <span class="text-danger text-sm" v-show="displayElement && errors.has($t('LOGIN').Password)">{{
                        errors.first($t('LOGIN').Password) }}</span>

                      <div class="flex flex-wrap justify-between mt-5">
                        <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3 remember-login-check">{{$t('LOGIN').Remember}}</vs-checkbox> -->
                        <b-form-checkbox v-model="checkbox_remember_me" class="form-switch custom-checkbox"
                          :class="{ 'mb-3': isDesktop, 'custom-checked': checkbox_remember_me }">{{ $t('LOGIN').Remember }}</b-form-checkbox>
                        <!-- <router-link :to="forgotPasswordLink" class="forgot-pass">{{$t('LOGIN').ForgotPass}}</router-link> -->
                      </div>
                      <div class="flex flex-row-reverse">
                        <vs-button @click="onLogin" class="btn-login">{{ $t('BUTTONS').Enter }}</vs-button>
                      </div>
                      <auth-links :fromPopup="fromPopup" :register="true" :forgotPass="true" :lostAccess="true"
                        @persist-email-store="persistEmailStore" @open-lost-access="$emit('open-lost-access')"
                        @open-forgot-password="$emit('open-forgot-password')"
                        @open-register="$emit('open-register')"></auth-links>
                    </div>
                  </div>
                  <div class="login-tabs-container content-login mt-10 confirm-email" v-if="displayConfirmEmail">
                    <!-- <vs-button class="btn-back-two-auth" type="flat" @click="displayConfirmEmail=!displayConfirmEmail">Voltar</vs-button> -->
                    <!-- <feather-icon icon="ChevronLeftIcon" @click="displayConfirmEmail=!displayConfirmEmail"
                  class="cursor-pointer mr-4 icon-back cursor-pointer"
                  svg-classes="w-6 h-6"
                  ></feather-icon> -->
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4 title-box-login items-center">{{ $t('LOGIN').Confirm_Email_Title }}</h4>
                      <p>{{ $t('LOGIN').Confirm_Email_Desc }}</p>
                      <p>{{ $t('LOGIN').Confirm_Email_Desc_Token_Val }}</p>
                      <!-- <p>Seu cadastro para acesso à demonstração da Plataforma Safras ainda não está concluído. Você precisa registrar na tela de cadastro o token enviado por Safras & Mercado ao seu endereço de e-mail.</p> -->
                      <!-- <p>Tempo de validade do token: até 2 horas.</p> -->
                      <!-- <p class="mt-2">{{$t('LOGIN').Confirm_Email_Desc_Sec}}</p> -->
                      <!-- <p>Não recebeu o e-mail?</p> -->
                      <p class="">
                      <div>{{ $t('LOGIN').Confirm_Email_Desc_Sec }}</div>
                      <small><a style="text-decoration: underline;" class="cursor-pointer"
                          @click.stop="resendTokenConfirmEmail">{{ $t('LOGIN').Click_Here }}</a> {{
                            $t('LOGIN').Resend_Token
                        }}</small>
                      </p>
                    </div>
                    <vs-input :name="$t('LOGIN').Code" id="confirmEmailToken" v-validate="'required'" icon-no-border
                      icon="icon icon-pass" icon-pack="feather" label="Código" v-model="confirmEmailToken"
                      class="w-full mb-3" />
                    <span class="text-danger text-sm" v-show="errors.has($t('LOGIN').Code)">{{
                      errors.first($t('LOGIN').Code) }}</span>

                    <div class="flex flex-row-reverse mt-5">
                      <vs-button @click="validateConfirmEmail" class="btn-login">{{ $t('BUTTONS').Enter }}</vs-button>
                    </div>
                  </div>
                  <div class="login-tabs-container content-login mt-10" v-if="displayEmailTwoFactorAuth && isDesktop">
                    <!-- <vs-button class="btn-back-two-auth" type="flat" @click="displayEmailTwoFactorAuth=!displayEmailTwoFactorAuth">Voltar</vs-button> -->
                    <feather-icon icon="ChevronLeftIcon" @click="displayEmailTwoFactorAuth = !displayEmailTwoFactorAuth"
                      class="btn-back-all" svg-classes="w-6 h-6"></feather-icon>
                    <div class="vx-card__title mb-5">
                      <h4 class="mb-4 title-box-login items-center">{{ $t('LOGIN').Two_Factor_Auth_Title }}</h4>
                      <p><span>{{ $t('LOGIN').Two_Factor_Auth_Desc }}</span></p>
                      <p><a style="text-decoration: underline;" class="cursor-pointer"
                          @click.stop="resendTokenTwoFactorAuth">Reenviar código</a>.</p>
                    </div>
                    <vs-input :name="$t('LOGIN').Code" id="emailToken" v-validate="'required'" icon-no-border
                      icon="icon icon-key" icon-pack="feather" label="Código" v-model="emailToken"
                      class="w-full mb-2" />
                    <span class="text-danger text-sm" v-show="errors.has($t('LOGIN').Code)">{{
                      errors.first($t('LOGIN').Code) }}</span>

                    <div class="flex flex-row-reverse mt-2">
                      <vs-button @click="validateTwoFactorAuthToken"
                        class="btn-login">{{ $t('BUTTONS').Enter }}</vs-button>
                    </div>
                  </div>
                  <div class="login-tabs-container content-login mt-10" v-if="displayQRCodeTwoFactorAuth">
                    <!-- <vs-button class="btn-back-two-auth" type="flat" @click="displayQRCodeTwoFactorAuth=!displayQRCodeTwoFactorAuth">Voltar</vs-button> -->
                    <feather-icon icon="ChevronLeftIcon" @click="displayQRCodeTwoFactorAuth = !displayQRCodeTwoFactorAuth"
                      class="cursor-pointer mr-4 icon-back cursor-pointer" svg-classes="w-6 h-6"></feather-icon>
                    <div class="vx-card__title mb-4">
                      <h4 class="mb-4 title-box-login item-center">{{ $t('LOGIN').Two_Factor_Auth_Title }}</h4>
                      <p style="font-size: smaller">Aponte a camera do celular no QR Code abaixo e digite o código para
                        entrar</p>
                    </div>
                  </div>
                  <!-- <div class="login-tabs-container content-login 5" v-if="displayEmailTwoFactorAuth">
                <vs-button class="btn-back-two-auth" type="flat" @click="displayEmailTwoFactorAuth=!displayEmailTwoFactorAuth">Voltar</vs-button>
                <div class="vx-card__title mb-5">
                  <h4 class="mb-4 title-box-login items-center">{{$t('LOGIN').Two_Factor_Auth_Title}}</h4>
                  <p>{{$t('LOGIN').Two_Factor_Auth_Desc}}</p>
                  <span>Não recebeu email? <a style="text-decoration: underline;" class="cursor-pointer" @click.stop="resendTokenTwoFactorAuth">Clique aqui</a> para reenviar o código</span>
                </div>
                <vs-input
                    name="emailToken"
                    id="emailToken"
                    v-validate="'required'"
                    icon-no-border
                    icon="icon icon-key"
                    icon-pack="feather"
                    label-placeholder="Código"
                    v-model="emailToken"
                    class="w-full mb-2"
                  />
                  <span class="text-danger text-sm" v-show="errors.has('emailToken')">{{ errors.first('emailToken') }}</span>

                    <div class="flex flex-row-reverse">
                      <vs-button @click="onLogin" class="btn-login">{{$t('BUTTONS').Enter}}</vs-button>
                    </div>
                </div>-->
                </div>
                <auth-footer-privacy @open-terms="displayPopupTermsCondition = !displayPopupTermsCondition"
                  @open-privacy="displayPolicyPage = !displayPolicyPage"></auth-footer-privacy>
              </div>

            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
      <div v-if="recaptchaEnabled">
        <vue-recaptcha ref="invisibleRecaptchaLogin" @verify="onVerifyRecaptcha" @expired="onExpiredRecaptcha"
          size="invisible" :sitekey="recaptchaKey" @error="onErrorRecaptcha" />
      </div>
      <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onCloseLogin"></div>
    </div>
  </div>
</template>

<script>
import authService from "../../providers/authService";
import AppConstants from './../../appConstants';
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import VueRecaptcha from 'vue-recaptcha';
import TermsUse from './help/TermsUse.vue';
import PrivacyPolicy from './help/PrivacyPolicy.vue';
import AuthFooterPrivacy from './AuthFooterPrivacy.vue';
import AuthLinks from './AuthLinks.vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Typewriter from 't-writer.js'
import localStorageHelper from '../../helpers/local-storage-helper';
import { BFormCheckbox } from 'bootstrap-vue'
import biometryHelper from "@/helpers/biometry-helper";
import messageDialogHelper from "@/helpers/message-dialog-helper";
import checkDeviceTypeHelper from "@/helpers/check-device-type-helper";
import VueI18n from "../../i18n/i18n";

export default {
  props: {
    fromPopup: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayElement: true,
      showErrors: false,
      email: '',
      password: '',
      checkbox_remember_me: false,
      forgotPasswordLink: AppConstants.NAVIGATION_PAGE_FORGOT_PASSWORD,
      newClientLink: this.$t('LOGIN').New_Here_Link,
      lostAccessLink: AppConstants.NAVIGATION_PAGE_LOST_ACCESS,
      inputPasswordType: 'password',
      displayEmailTwoFactorAuth: false,
      displayQRCodeTwoFactorAuth: false,
      displayConfirmEmail: false,
      emailToken: '',
      qrCodeToken: '',
      confirmEmailToken: '',
      displayPopupPolicy: false,
      recaptchaVerified: false,
      displayPopupTermsCondition: false,
      displayPolicyPage: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.3,
        swipeEasing: true
      },
    };
  },
  mounted() {
    // this.$i18n.locale = getCodeLangFromBrowser();
    if (this.isDesktop) {
      this.injectTypeWriter();
    }
    const emailStore = this.getEmailFromStore();
    if (emailStore) {
      this.email = emailStore;
      this.checkbox_remember_me = true;
      document.getElementById('password').focus();
    } else {
      document.getElementById('email').focus();
    }

    if(this.$store.state.insetTop) {
      document.querySelector('.full-page-bg-color').style.top = this.$store.state.insetTop + 'px';
    }

    if(this.$store.state.insetBottom) {
      document.querySelector('.full-page-bg-color').style.bottom = this.$store.state.insetBottom + 'px';
    }

    // console.log('[mounted] isReactApp', this.$store.state.insetTop, document.querySelector('.full-page-bg-color'));
  },
  async created() {
    
  },
  computed: {
    isReactApp() {
      return !this.isDesktop && checkDeviceTypeHelper.isNativeApp() && checkDeviceTypeHelper.isReactApp();
    },
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    isInputPasswordTypeText() {
      return this.inputPasswordType == 'text';
    },
    recaptchaEnabled() {
      return this.$config.mobile_recaptcha_enabled;
    },
    recaptchaKey() {
      if (this.isDesktop) {
        return this.$config.desktop_recaptcha_key;
      } else {
        return this.$config.mobile_recaptcha_key;
      }
    },
  },
  watch: {
    "$i18n.locale"() {
      if (this.isDesktop) {
        this.injectTypeWriter();
      }
    }
  },
  methods: {
    onErrorRecaptcha(val) {
      console.log('[onErrorRecaptcha]', val);
    },
    injectTypeWriter() {
      const target = document.querySelector('.video-content-text');
      const a = document.querySelector('.title-video');
      if (a) {
        target.removeChild(a);
      }
      const data = document.createElement('span');
      data.className = 'title-video';
      target.appendChild(data);

      // const data = document.querySelector('.title-video');
      // console.log(target);
      const options = {
        loop: true,
        typeColor: 'white',
        typeSpeed: 80,
        deleteSpeed: 10,
      }
      // Safras & Mercado: A sua casa de análises do Brasil e América Latina
      // Safras & Mercado: Su casa de análisis de Brasil y América Latina
      // Safras & Mercado: Your best source for AG research on Brazil and Latin America

      const writer = new Typewriter(data, options)
        .changeCursorColor('white')
        .type(this.$t('LOGIN').Text_Market)
        .rest(30000000)
        .clear()
        .start();
    },
    deleteElement() {
      this.displayElement = false;
    },
    showElementAgain() {
      if (this.displayElement) {
        this.elementState = false;
      } else {
        this.elementState = true;
      }

      this.displayElement = !this.displayElement;
    },
    onCloseLogin() {
      this.$emit('closelogin');
    },
    onExpiredRecaptcha() {
      console.log('Expired');
      this.recaptchaVerified = false;
    },
    onVerifyRecaptcha() {
      // console.log('Verify: ' + response);
      this.recaptchaVerified = true;
      this.sendLogin();
    },
    resendTokenConfirmEmail() {
      authService
        .sendConfirmEmailToken(this.email, new URLSearchParams())
        .then(() => {
          messagesNotifyHelper.successNotify(this.$t('LOGIN').Confirm_Email_Title, this.$t('LOGIN').Confirm_Email_Send_Token);
          this.confirmEmailToken = '';
        })
        .catch(error => {
          console.log(error);
        });
    },
    resendTokenTwoFactorAuth() {
      authService
        .resendTokenTwoFactorAuth(this.email, new URLSearchParams())
        .then(() => {
          messagesNotifyHelper.successNotify(this.$t('LOGIN').Confirm_Email_Title, this.$t('LOGIN').Confirm_Email_Send_Token);
          this.emailToken = '';
        })
        .catch(error => {
          console.log(error);
        });
    },
    getDeviceId() {
      let deviceId = '';
      if (this.isReactApp) {
        deviceId = localStorageHelper.getOneSignalID() || '';
      } else {
        deviceId = localStorage.getItem('deviceId') || '';
      }
      if (deviceId == undefined || deviceId == 'undefined') return '';
      return deviceId;
    },
    validateConfirmEmail() {
      const form = {
        email: this.email,
        token: this.confirmEmailToken ? this.confirmEmailToken.toLowerCase() : this.confirmEmailToken
      }
      const deviceId = this.getDeviceId();
      if (deviceId) form.device_id = deviceId;
      authService
        .validateConfirmEmailToken(form, new URLSearchParams())
        .then(response => {
          this.successLogin(response);
          // this.newSuccessLogin(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    validateTwoFactorAuthToken() {
      const form = {
        email: this.email,
        token: this.emailToken ? this.emailToken.toLowerCase() : this.emailToken
      }
      const deviceId = this.getDeviceId();
      if (deviceId) form.device_id = deviceId;

      authService
        .validateTwoFactorAuthToken(form, new URLSearchParams())
        .then(response => {
          this.successLogin(response);
          // this.newSuccessLogin(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    onClose() {
      if (this.fromPopup) {
        this.$emit('close');
        return;
      }
      this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
    },
    openForgotPassword() {
      // if (this.isDesktop) {
      //   this.$emit('open-forgot-password');
      // } else {
      //   }
      this.persistEmailStore();
      this.$router.push(AppConstants.NAVIGATION_PAGE_FORGOT_PASSWORD);
    },
    openLostAccess() {
      // if (this.isDesktop) {
      //   this.$emit('open-lost-access');
      // } else {
      //   }
      this.persistEmailStore();
      this.$router.push(AppConstants.NAVIGATION_PAGE_LOST_ACCESS);
    },
    openRegister() {
      // if (this.isDesktop) {
      //   this.$emit('open-register');
      // } else {
      //   }
      this.$router.push(AppConstants.NAVIGATION_PAGE_REGISTER);
    },
    switchInputPasswordType() {
      if (this.inputPasswordType === 'password') {
        this.inputPasswordType = 'text';
      } else {
        this.inputPasswordType = 'password';
      }
    },
    handleLoginStore() {
      if (this.checkbox_remember_me) {
        this.persistEmailStore();
      } else {
        this.purgeEmailStore();
      }
    },
    sendLogin() {
      console.log('sendlogin')
      const form = {
        email: this.email.toLowerCase(),
        password: this.password,
        isDesktop: checkDeviceTypeHelper.isNativeApp(),
      };

      const deviceId = this.getDeviceId();
      if (deviceId) form.device_id = deviceId;

      authService
        .login(form, new URLSearchParams())
        .then(response => {
          this.handleLoginStore();
          if (response.notEmailConfirmed) {
            this.displayConfirmEmail = true;
          } else if (response.authEmail) {
            this.displayEmailTwoFactorAuth = true;
          } else if (response.authQRCode) {
            this.displayQRCodeTwoFactorAuth = true;
          } else {
            this.successLogin(response);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // sendClientDeviceId() {
    //   const deviceId = localStorage.deviceId;
    //   alert('setting deviceid: ' + deviceId);
    //   const form = {
    //     deviceId,
    //   }
    //   pushwooshService.sendClientDeviceId(form, new URLSearchParams())
    //     .then(response => {
    //       alert(`saved device id ${deviceId} with success`);
    //     })
    //     .catch(error => {
    //       alert(`error saving device id ${deviceId}`);
    //     });
    // },
    async successLogin(response) {
      console.log('[successLogin]', response);
      this.$store.dispatch('updateOnLogin', true);
      // response[0].email = this.email;
      // this.onClose();
      setTimeout(async () => {
        authService.successLogin(response, false);

        // redirect url
        // console.log('route query: ', this.$route.query);
        const routeQuery = Object.keys(this.$route.query).filter(q => q != 'to');
        const routePath = {
          path: this.$route.query.to ? this.$route.query.to : "/"
        };

        if (routeQuery && this.isDesktop) {
          routePath.query = {};
          routeQuery.forEach(key => {
            routePath.query[key] = this.$route.query[key];
          });
        }
        localStorageHelper.updateEventOnLogin(true);

        if (checkDeviceTypeHelper.isNativeApp()) {
          if (checkDeviceTypeHelper.isReactApp()) {
            try {
              console.log('[waitCheckHasBiometry] init login');
              const biometryType = await biometryHelper.waitCheckHasBiometry();
              console.log('[biometryType]', biometryType);
              if (biometryType) {
                this.newTryShowTipBiometryOnLogin(routePath);
              } else {
                this.reloadApp(routePath);
              }
            } catch (error) {
              this.reloadApp(routePath);
            }
          } else {
            console.log('[isNativeApp]');
            biometryHelper.hasBiometry(
              (response) => {
                console.log('[hasBiometry] ', response);
                this.$store.dispatch('updateIsBiometryAvailable', true);
                // this.$store.dispatch('updateBiometryType', response);
                this.$store.dispatch('updateBiometryType', response === 'face' ? 'face' : 'other');
                this.tryShowTipBiometryOnLogin(routePath);
              },
              (error) => {
                console.info('Biometrics unavailable:', error);
                this.reloadApp(routePath);
              }
            );
          }
        } else {
          this.reloadApp(routePath);
        }
      }, 400)
    },
    reloadApp(routePath) {
      if (routePath.path != '/') {
        this.$router.push(routePath);
        setTimeout(() => { document.location.reload(); }, 100);
      } else {
        document.location.reload();
      }
    },
    tryShowTipBiometryOnLogin(routePath) {
      // User has already activated biometry
      if (localStorageHelper.getBiometry() === "1") {
        console.log('[tryShowTipBiometryOnLogin] User has already activated biometry');
        this.reloadApp(routePath);
        return;
      }

      // User asked to not show the hint again
      if (localStorageHelper.getUserAfterLoginShowBiometry()) {
        console.log('[getUserAfterLoginShowBiometry]');
        const title = VueI18n.t('BIOMETRY').Biometry_Confirm_Title || 'Reconhecimento de biometria para acessar a sua conta';
        const confirmText = VueI18n.t('BIOMETRY').Biometry_Confirm_Activate_Text || 'Deseja ativar a biometria agora para acessos rápidos e protegidos?';
        const activateText = VueI18n.t('BIOMETRY').Activate || 'Ativar';
        const cancelText = VueI18n.t('BIOMETRY').Cancel || 'Cancelar';
        messageDialogHelper.displayDialogConfirmCancelWithText(title, confirmText, activateText, cancelText, (callback) => {
          if (callback == 'accept') {
            const refreshToken = localStorageHelper.getCurrentUser().refreshToken;
            console.log('[tryShowTipBiometryOnLogin] call biometryHelper.registerSecret: ', refreshToken);
            biometryHelper.registerSecret(refreshToken, () => {
              localStorageHelper.updateUserAfterLoginShowBiometry(false);
              localStorageHelper.updateBiometry("1");
              this.$store.dispatch('updateBiometrySecrets', refreshToken);

              setTimeout(() => this.reloadApp(routePath), 100);
            },
              () => {
                this.reloadApp(routePath);
              });
          } else if (callback == 'cancel') {
            this.reloadApp(routePath);
          }
        });
      } else {
        this.reloadApp(routePath);
      }
    },
    async newTryShowTipBiometryOnLogin(routePath) {
      // User has already activated biometry
      if (localStorageHelper.getBiometry() === "1") {
        this.reloadApp(routePath);
        return;
      }

      // User asked to not show the hint again
      if (localStorageHelper.getUserAfterLoginShowBiometry()) {
        const title = VueI18n.t('BIOMETRY').Biometry_Confirm_Title || 'Reconhecimento de biometria para acessar a sua conta';
        const confirmText = VueI18n.t('BIOMETRY').Biometry_Confirm_Activate_Text || 'Deseja ativar a biometria agora para acessos rápidos e protegidos?';
        const activateText = VueI18n.t('BIOMETRY').Activate || 'Ativar';
        const cancelText = VueI18n.t('BIOMETRY').Cancel || 'Cancelar';
        messageDialogHelper.displayDialogConfirmCancelWithText(title, confirmText, activateText, cancelText, async (callback) => {
            if (callback == 'accept') {
              try {
                const refreshToken = localStorageHelper.getCurrentUser().refreshToken;
                const saveBiometrySec = await biometryHelper.waitSaveBiometrySecret(refreshToken);
                if (saveBiometrySec) {
                  localStorageHelper.updateUserAfterLoginShowBiometry(false);
                  localStorageHelper.updateBiometry("1");
                } else {
                  messagesNotifyHelper.errorNotify('Biometria', 'Não foi possível confirmar a biometria');
                }
                setTimeout(() => this.reloadApp(routePath), 200);
              } catch (error) {
                this.reloadApp(routePath)
              }
            } else if (callback == 'cancel') {
              this.reloadApp(routePath);
            }
          });
      } else {
        this.reloadApp(routePath);
      }
    },
    onLogin() {
      this.showElementAgain()
      this.showErrors = true;

      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.recaptchaEnabled) {
            if (this.recaptchaVerified) {
              this.sendLogin();
            } else {
              this.$refs.invisibleRecaptchaLogin.execute();
            }
          } else {
            this.sendLogin();
          }
        } else {
          messagesNotifyHelper.errorNotify((this.$t('LOGIN').Notify_Error_Title), this.$t('LOGIN').Notify_Error_Message);
        }
      });
    },
    focusPassword() {
      document.getElementById('password').focus();
    },
    persistEmailStore() {
      if (this.email) {
        localStorage.email = this.email;
      }
    },
    purgeEmailStore() {
      localStorage.email = '';
    },
    getEmailFromStore() {
      return localStorage.email;
    },
  },
  components: {
    VueRecaptcha,
    TermsUse,
    PrivacyPolicy,
    AuthFooterPrivacy,
    AuthLinks,
    VuePerfectScrollbar,
    BFormCheckbox,
    // Flags
  }
};
</script>

<style lang="scss"></style>
